import { Component, Input, OnInit, inject } from '@angular/core';

import { MenuActionsService, MenuContentItem, TrackingService } from '@frontend/vanilla/core';
import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { ImageComponent } from '@frontend/vanilla/shared/image';

@Component({
    imports: [TrustAsHtmlPipe, ImageComponent, IconCustomComponent],
    selector: 'vn-help-card',
    templateUrl: 'help-card.html',
})
export class HelpCardComponent implements OnInit {
    private menuActionsService = inject(MenuActionsService);
    private trackingService = inject(TrackingService);

    @Input() item: MenuContentItem;

    ngOnInit() {
        this.trackingService.triggerEvent('contentView', {
            'component.CategoryEvent': 'my profile',
            'component.LabelEvent': 'my hub',
            'component.ActionEvent': 'load',
            'component.PositionEvent': 'not applicable',
            'component.LocationEvent': 'my hub page',
            'component.EventDetails': 'help & contact section',
            'component.URLClicked': 'not applicable',
        });
    }

    itemClick(event: Event, item: MenuContentItem, origin: string) {
        this.menuActionsService.processClick(event, item, origin);
    }
}
